import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const KioskIcon: FC<SvgProps> = ({ fill, ...props }) => {
    const color = fill || 'currentColor'

    return (
        <Svg width={20} height={20} fill="none" viewBox="0 0 32 32" {...props}>
            <Path
                fill={color}
                d="M23.15 1.98H8.86c-.75 0-1.34.62-1.3 1.37L8.6 22.09c.04.69.61 1.22 1.29 1.22h12.22c.69 0 1.26-.54 1.29-1.22l1.04-18.74a1.3 1.3 0 0 0-1.29-1.37m-8.46 19.87h-2.06c-.35 0-.64-.29-.64-.64s.29-.64.64-.64h2.06c.35 0 .64.29.64.64s-.29.64-.64.64m0-2.31h-2.06c-.35 0-.64-.29-.64-.64s.29-.64.64-.64h2.06c.35 0 .64.29.64.64s-.29.64-.64.64m4.69 2.31h-2.06c-.35 0-.64-.29-.64-.64s.29-.64.64-.64h2.06c.35 0 .64.29.64.64s-.29.64-.64.64m0-2.31h-2.06c-.35 0-.64-.29-.64-.64s.29-.64.64-.64h2.06c.35 0 .64.29.64.64s-.29.64-.64.64m2.96-3.48c-.03.48-.4.85-.85.85h-11.2c-.46 0-.84-.38-.85-.86L8.96 4.12c-.02-.51.37-.94.85-.94h12.38c.49 0 .88.44.85.96l-.7 11.93zM19.47 23.69h-7.18v4.9h7.18zM21.402 28.97h-11.04a.26.26 0 0 0-.26.26v.53c0 .144.116.26.26.26h11.04a.26.26 0 0 0 .26-.26v-.53a.26.26 0 0 0-.26-.26M20.402 23.69h-.55v4.9h.55zM11.902 23.69h-.55v4.9h.55z"
            />
            <Path
                fill={color}
                d="M10.819 7.31c-.16 0-.31-.07-.42-.2-.2-.23-.17-.58.06-.78l2.08-1.77a.554.554 0 0 1 .72.84l-2.08 1.77c-.1.09-.23.13-.36.13zM11.612 9.6c-.16 0-.31-.07-.42-.2-.2-.23-.17-.58.06-.78L15.502 5a.554.554 0 0 1 .72.84l-4.25 3.62c-.1.09-.23.13-.36.13z"
            />
        </Svg>
    )
}

export default KioskIcon
